import React from 'react';
import DateRangePicker from './';
import './index.module.sap.scss';

const SapDateRangePicker = props => <DateRangePicker {...props} />;

export default SapDateRangePicker;
